import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface ApplicationSubmissionSuccessProps {
    messageKey: string;
}

const ApplicationSubmissionSuccess: FC<ApplicationSubmissionSuccessProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center w-full py-10 bg-backgroundBlock border border-backgroundButton rounded-lg mb-[60px] dmax2:mb-10">
            <div className="flex flex-col items-center justify-center">
                <span className="H32B dmax2:H20B text-textWhite text-center mb-9 dmax2:mb-7 tmax4:max-w-[328px]">
                    {t(props.messageKey)}
                </span>
                <Link
                    to="/catalog"
                    className="button dmin2:H16 td2:H14 tmax1:H12 dmin2:h-[50px] td2:h-[40px] tmax1:h-[37px] px-6"
                >
                    <div className="mb-[2px]">{t("work.applicationCreation.backToCatalog")}</div>
                </Link>
            </div>
        </div>
    );
};

export default ApplicationSubmissionSuccess;
